import { FormStateWithEnteredValues, EmbeddedValueForPdf } from '../types';
import { LOCAL_CONSTANT } from '../localConstant';

interface pdfCreation {
  formValue: FormStateWithEnteredValues;
}
export class PdfCreation implements pdfCreation {
  
  formValue: FormStateWithEnteredValues;

  constructor(formValue: FormStateWithEnteredValues) {
    this.formValue = formValue;
  }

  /**
   * PDF作成のためのデータを取得するメソッドです。
   * @return {object} PDF作成のためのデータ
   */
  public getFormValue(): any {

    const pdfDocument: any = {
      info: {
        title: this.formValue.documentName,
        author: '特許庁審査業務部',
        subject: '特殊申請書類作成支援ツール',
        keywords: JSON.stringify(this.getEmbeddedValueForPdf()),
      },
      content:[
        {text: this.formValue.documentName.value, alignment: 'center', margin: [25, 10, 25, 10]},
        {text: `（${this.charToJapaneseCalendar(this.formValue.submissionDate.value)}）`, alignment: 'right', margin: [25, 10, 25, 10]},
        {text: `特許庁長官            殿`, margin: [25, 10, 25, 10]},
        {text: `${this.getPdfItemIndex('登録番号')}    ${this.formValue.jurisdiction.value}番号`, margin: [25, 10, 25, 10]},
        {text: this.getRegistrationNumbersForPdf(), margin: [75, 0, 25, 0]},
        {text: `${this.getPdfItemIndex('申出人')}    申出人`, margin: [25, 10, 25, 10]},
        {text: this.getApplicantForPdf(), margin: [75, 0, 25, 0]},
        {text: this.formValue.agency.name.value !== '' ? `${this.getPdfItemIndex('代理人')}    代理人` : '', margin: this.formValue.agency.name.value !== '' ? [25, 10, 25, 10] : [0, 0, 0, 0]},
        {text: this.formValue.agency.name.value !== '' ? this.getAgencyForPdf() : '', margin: this.formValue.agency.name.value !== '' ? [75, 0, 25, 0] : [0, 0, 0, 0]},
        {text: `${this.getPdfItemIndex('権利者')}    ${this.formValue.jurisdiction.value.replace('登録', '')}権者`, margin: [25, 10, 25, 10]},
        {text: this.getRightHoldersForPdf(), margin: this.getRightHoldersForPdf() !== '' ? [75, 0, 25, 0] : [0, 0, 0, 0]},
        {text: this.formValue.specialNotesOnFee.parentItem.value ? `${this.getPdfItemIndex('特許料等に関する特記事項')}    特許料等に関する特記事項\n${this.formValue.specialNotesOnFee.parentItem.value}${this.formValue.specialNotesOnFee.childItem.value}に掲げる者に該当する特許権者である。減免申請書の提出を省略する。\n` : '', margin: this.formValue.specialNotesOnFee.parentItem.value ? [25, 10, 25, 10] : [0, 0, 0, 0]},
        {text: this.formValue.other.value ? `${this.getPdfItemIndex('その他')}    その他\n${this.formValue.other.value}\n` : '', margin: this.formValue.other.value ? [25, 10, 25, 10] : [0, 0, 0, 0]},
      ],
      defaultStyle: {
        font: 'IPA_mincho',
        fontSize: 12,
        alignment: 'left',
        lineHeight: 1.7,
        margin: [25, 0, 25, 0]
      },
    };

    if(this.getRegistrationNumbersForAnotherPdf()) {
      this.getRegistrationNumbersForAnotherPdf().forEach((formatRegistrationNumber, index) => {
        if((index + 1) % 2 === 1) {
          if(index === 0) {
            pdfDocument.content.push({text: '', pageBreak: 'after'});
            pdfDocument.content.push({text: '別紙', margin:[25, 0, 25, 25]});
          } else {
            pdfDocument.content.push({text: '', pageBreak: 'after'});
            pdfDocument.content.push({text: '\n', margin:[25, 0, 25, 25]});
          }
          pdfDocument.content.push({
            columns: [
              {
                width: '50%',
                text: formatRegistrationNumber,
                alignment: 'center',
                margin:[25, 0, 25, 0]
              }
            ]
          })
        } else {
          pdfDocument.content[pdfDocument.content.length - 1].columns.push(
            {
              width: '50%',
              text: formatRegistrationNumber,
              alignment: 'center',
              margin:[25, 0, 25, 0]
            }
          );
        }

      });
    }
    return pdfDocument;
  }

  /**
   * PDF上のインデックスを取得する関数
   * @param {string} itemName 項目名
   * @return {string} 項目番号（全角数字）
   */
  public getPdfItemIndex = (itemName: string): string => {
    if(itemName === '登録番号') {
      return '１';
    } else if(itemName === '申出人') {
      return '２';
    } else if(itemName === '代理人') {
      return '３';
    } else if(itemName === '権利者') {
      if(this.formValue.agency.name.value !== '') {
        return '４';
      } else {
        return '３';
      }
    } else if(itemName === '特許料等に関する特記事項') {
      if(this.formValue.agency.name.value !== '') {
        return '５';
      } else {
        return '４';
      }
    } else if(itemName === 'その他') {
      if(this.formValue.agency.name.value !== '') {
        if(this.formValue.specialNotesOnFee.parentItem.value !== '' && this.formValue.specialNotesOnFee.childItem.value !== '' ) {
          return '６';
        } else {
          return '５';
        }
      } else {
        if(this.formValue.specialNotesOnFee.parentItem.value !== '' && this.formValue.specialNotesOnFee.childItem.value !== '' ) {
          return '５';
        } else {
          return '４';
        }
      }
    }
    return '';
  }

  public getEmbeddedValueForPdf = (): EmbeddedValueForPdf => {
    return {
      '書類名': this.formValue.documentName.value,
      '提出日': this.formValue.submissionDate.value,
      '法域': this.formValue.jurisdiction.value,
      '登録番号': this.formValue.registrationNumbers.map((registrationNumber) => {
        return registrationNumber.value;
      }),
      '申出人': {
        '識別番号': this.formValue.applicant.identificationNumber.value,
        '住所又は居所': this.formValue.applicant.address.value,
        '氏名又は名称': this.formValue.applicant.name.value,
        '代表者': this.formValue.applicant.representative.value,
        '電話番号': this.formValue.applicant.phoneNumber.value,
        '納付方法': {
          '納付種別': this.formValue.applicant.payment.method.value,
          '納付番号': this.formValue.applicant.payment.paymentNumber.value
        }
      },
      '代理人': {
        '識別番号': this.formValue.agency.identificationNumber.value,
        '住所又は居所': this.formValue.agency.address.value,
        '氏名又は名称': this.formValue.agency.name.value,
        '代表者': this.formValue.agency.representative.value,
        '電話番号': this.formValue.agency.phoneNumber.value
      },
      '権利者': this.formValue.rightHolders.map((rightHolder) => {
        return ({
          '識別番号': rightHolder.identificationNumber.value,
          '住所又は居所': rightHolder.address.value,
          '氏名又は名称': rightHolder.name.value
        });
      }),
      '特許料等に関する特記事項': {
        '親項目': this.formValue.specialNotesOnFee.parentItem.value,
        '子項目': this.formValue.specialNotesOnFee.childItem.value
      },
      'その他': this.formValue.other.value
    };
  }

  /**
   * フォームにエラーが存在しているか判断するメソッドです。
   * @return {boolean} - エラー有無
   */
  public isError = (): boolean => {
    let result = false;

    result = this.formValue.documentName.value === '' || this.formValue.documentName.errorMessage !== '' ? true : result;
    result = this.formValue.submissionDate.value === '' || this.formValue.submissionDate.errorMessage !== '' ? true : result;
    result = this.formValue.jurisdiction.value === '' || this.formValue.jurisdiction.errorMessage !== '' ? true : result;
    this.formValue.registrationNumbers.forEach((registrationNumber) => {
      result = registrationNumber.value === '' || registrationNumber.errorMessage !== '' ? true : result;
    });
    result = this.formValue.applicant.identificationNumber.value === '' || this.formValue.applicant.identificationNumber.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.address.value === '' || this.formValue.applicant.address.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.name.value === '' || this.formValue.applicant.name.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.representative.errorMessage !== '' ? true : result;
    result = (this.formValue.documentName.value === '自動納付申出書' && this.formValue.applicant.payment.method.value === '') || this.formValue.applicant.payment.method.errorMessage !== '' ? true : result;
    result = (this.formValue.documentName.value === '自動納付申出書' && this.formValue.applicant.payment.paymentNumber.value === '') || this.formValue.applicant.payment.paymentNumber.errorMessage !== '' ? true : result;
    result = (this.formValue.agency.identificationNumber.value === '' && (this.formValue.agency.address.value !== '' || this.formValue.agency.name.value !== '' || this.formValue.agency.representative.value !== '' || this.formValue.agency.phoneNumber.value !== '')) || this.formValue.agency.identificationNumber.errorMessage !== '' ? true : result;
    result = (this.formValue.agency.address.value === '' && (this.formValue.agency.identificationNumber.value !== '' || this.formValue.agency.name.value !== '' || this.formValue.agency.representative.value !== '' || this.formValue.agency.phoneNumber.value !== '')) || this.formValue.agency.address.errorMessage !== '' ? true : result;
    result = (this.formValue.agency.name.value === '' && (this.formValue.agency.identificationNumber.value !== '' || this.formValue.agency.address.value !== '' || this.formValue.agency.representative.value !== '' || this.formValue.agency.phoneNumber.value !== '')) || this.formValue.agency.name.errorMessage !== '' ? true : result;
    result = this.formValue.agency.representative.errorMessage !== '' ? true : result;
    this.formValue.rightHolders.forEach((rightHolder) => {
      result = rightHolder.identificationNumber.errorMessage !== '' ? true : result;
      result = rightHolder.address.value === '' || rightHolder.address.errorMessage !== '' ? true : result;
      result = rightHolder.name.value === '' || rightHolder.name.errorMessage !== '' ? true : result;
    });
    result = this.formValue.specialNotesOnFee.parentItem.errorMessage !== '' ? true : result;
    result = this.formValue.specialNotesOnFee.childItem.errorMessage !== '' ? true : result;
    result = this.formValue.other.errorMessage !== '' ? true : result;

    return result;
  }

  /**
   * 文字列（YYYY-MM-DD）を和暦（令和YY年MM月DD日）に変換する
   * @param {string} inputValue YYYY-MM-DD形式の文字列
   * @return {string} 令和YY年MM月DD日形式に変換した文字列
   */
  private charToJapaneseCalendar = (inputValue: string): string => {
    return new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {year: 'numeric', month: 'long', day: 'numeric'}).format(new Date(inputValue));
  }

  /**
   * PDF上の「申出人」欄に入力された申出人情報ををPDF上に記載するためのフォーマット（文字列変換）処理をおこなう内部メソッド
   * （フォーマット例）
   *      識別番号  NNNNNNNNN
   *      住所（居所）  東京都千代田区霞ヶ関３－４－３
   *      氏名（名称）  株式会社XXXX
   *      代表者  特許　太郎
   *      電話番号  090-NNNN-NNNN
   *      予納台帳      NNNNNNNNNNNN
   * @param {Applicant} applicant - 出願人情報
   * @param {boolean} isAgencyProceedings - 代理人手続か否か
   * @returns {string} - 提出者（委任者）情報
   */
  private getApplicantForPdf = (): string => {
    return `${this.formValue.applicant.identificationNumber.value ? `識別番号    ${this.formValue.applicant.identificationNumber.value}\n` : ''}${this.formValue.applicant.address.value ? `住所又は居所    ${this.formValue.applicant.address.value}\n` : ''}${this.formValue.applicant.name.value ? `氏名又は名称    ${this.formValue.applicant.name.value}\n` : ''}${this.formValue.applicant.representative.value ? `代表者    ${this.formValue.applicant.representative.value}\n` : ''}${this.formValue.applicant.phoneNumber.value ? `電話番号    ${this.formValue.applicant.phoneNumber.value}\n` : ''}${this.formValue.applicant.payment.method.value && this.formValue.applicant.payment.paymentNumber.value ? `${this.formValue.applicant.payment.method.value}番号    ${this.formValue.applicant.payment.paymentNumber.value}\n` : ''}\n`;
  };

  /**
   * PDF上の「代理人」欄に入力された代理人情報ををPDF上に記載するためのフォーマット（文字列変換）処理をおこなう内部メソッド
   * （フォーマット例）
   *      識別番号  NNNNNNNNN
   *      住所（居所）  東京都千代田区霞ヶ関３－４－３
   *      氏名（名称）  株式会社XXXX
   *      代表者  特許　太郎
   *      電話番号  090-NNNN-NNNN
   * @returns {string} - 提出者（委任者）情報
   */
  private getAgencyForPdf = (): string => {
    return `${this.formValue.agency.identificationNumber.value ? `識別番号    ${this.formValue.agency.identificationNumber.value}\n` : ''}${this.formValue.agency.address.value ? `住所又は居所    ${this.formValue.agency.address.value}\n` : ''}${this.formValue.agency.name.value ? `氏名又は名称    ${this.formValue.agency.name.value}\n` : ''}${this.formValue.agency.representative.value ? `代表者    ${this.formValue.agency.representative.value}\n` : ''}${this.formValue.agency.phoneNumber.value ? `電話番号    ${this.formValue.agency.phoneNumber.value}\n` : ''}\n`;
  };

  /**
   *  PDF上の「権利者」欄に入力された権利者情報をPDF上に記載するためのフォーマット（文字列変換）処理
   *     （フォーマット例）
   *      識別番号  NNNNNNNNN
   *      住所（居所）  東京都千代田区霞ヶ関３－４－３
   *      氏名（名称）  株式会社XXXX
   * @return {string} 文字列変換した代理人情報
   */
  private getRightHoldersForPdf = () => {
    let result = '';
    this.formValue.rightHolders.forEach((rightHolder) => {
      result += `${rightHolder.identificationNumber.value ? `識別番号    ${rightHolder.identificationNumber.value}\n` : ''}${rightHolder.address.value ? `住所又は居所    ${rightHolder.address.value}\n` : ''}${rightHolder.name.value ? `氏名又は名称    ${rightHolder.name.value}\n` : ''}\n`;
    });
    return result;
  }

  /**
   *  「特許（登録）番号」欄に入力された特許（登録）番号をPDF上に記載するためのフォーマット（文字列変換）処理
   *      特許（登録）番号がDEFINE.MAX_REGISTRATION_NUMBER_COUNT件以上入力された場合は別紙に記載。
   *     （フォーマット例）
   *      特許第NNNNNNN号
   *      特許第NNNNNNN号
   * @param {void}
   * @return {string} 文字列変換した特許（登録）番号情報
   */
  private getRegistrationNumbersForPdf = () => {
    if(this.formValue.registrationNumbers.length >= LOCAL_CONSTANT.MAX_REGISTRATION_NUMBER_COUNT) {
      return '（別紙の通り）\n\n';
    } else {
      let joinRegistrationNumbers = '';
      this.formValue.registrationNumbers && this.formValue.registrationNumbers.forEach((registrationNumber) => {
        joinRegistrationNumbers += `${this.formValue.jurisdiction.value}第${registrationNumber.value}号\n`
      });

      return joinRegistrationNumbers + '\n';
    }
  };

  /**
   *  PDF上の別紙に特許（登録）番号を記載するためのフォーマット処理
   *    「特許（登録）番号」欄に入力された特許（登録）番号を PDF上の別紙に記載するためのフォーマット（文字列変換）処理
   *     （フォーマット例）
   *      特許第NNNNNNN号
   *      特許第NNNNNNN号
   * @param {void}
   * @return {string[]} 文字列変換した特許（登録）番号情報
   */
  private getRegistrationNumbersForAnotherPdf = () => {
    if(this.formValue.registrationNumbers.length >= LOCAL_CONSTANT.MAX_REGISTRATION_NUMBER_COUNT) {
      let registrationNumbersArray: string[] = [];
      let tempString = '';
      this.formValue.registrationNumbers && this.formValue.registrationNumbers.forEach((registrationNumber, index) => {
        tempString += `${index+1}. ${this.formValue.jurisdiction.value}第${registrationNumber.value}号\n`;
        if(index % 35 === 34) {
          registrationNumbersArray.push(tempString);
          tempString = '';
        } else if(index === this.formValue.registrationNumbers.length - 1) {
          registrationNumbersArray.push(tempString);
        }
      });
      return registrationNumbersArray;
    } else {
      return [];
    }
  };

}

/**
  * フォームにエラーが存在しているか判断するメソッドです。
  * @param {FormStateWithEnteredValues} - 入力されたフォームの値
  * @return {boolean} - エラー有無
  */
export const isError = (formValue: FormStateWithEnteredValues): boolean => {
  let result = false;
  result = formValue.documentName.value === '' || formValue.documentName.errorMessage !== '' ? true : result;
  result = formValue.submissionDate.value === '' || formValue.submissionDate.errorMessage !== '' ? true : result;
  result = formValue.jurisdiction.value === '' || formValue.jurisdiction.errorMessage !== '' ? true : result;
  formValue.registrationNumbers.forEach((registrationNumber) => {
    result = registrationNumber.value === '' || registrationNumber.errorMessage !== '' ? true : result;
  });
  result = formValue.applicant.identificationNumber.value === '' || formValue.applicant.identificationNumber.errorMessage !== '' ? true : result;
  result = formValue.applicant.address.value === '' || formValue.applicant.address.errorMessage !== '' ? true : result;
  result = formValue.applicant.name.value === '' || formValue.applicant.name.errorMessage !== '' ? true : result;
  result = formValue.applicant.representative.errorMessage !== '' ? true : result;
  result = formValue.applicant.payment.method.value === '' || formValue.applicant.payment.method.errorMessage !== '' ? true : result;
  result = formValue.applicant.payment.paymentNumber.value === '' || formValue.applicant.payment.paymentNumber.errorMessage !== '' ? true : result;
  result = (formValue.agency.identificationNumber.value === '' && (formValue.agency.address.value !== '' || formValue.agency.name.value !== '' || formValue.agency.representative.value !== '' || formValue.agency.phoneNumber.value !== '')) || formValue.agency.identificationNumber.errorMessage !== '' ? true : result;
  result = (formValue.agency.address.value === '' && (formValue.agency.identificationNumber.value !== '' || formValue.agency.name.value !== '' || formValue.agency.representative.value !== '' || formValue.agency.phoneNumber.value !== '')) || formValue.agency.address.errorMessage !== '' ? true : result;
  result = (formValue.agency.name.value === '' && (formValue.agency.identificationNumber.value !== '' || formValue.agency.address.value !== '' || formValue.agency.representative.value !== '' || formValue.agency.phoneNumber.value !== '')) || formValue.agency.name.errorMessage !== '' ? true : result;
  result = formValue.agency.representative.errorMessage !== '' ? true : result;
  formValue.rightHolders.forEach((rightHolder) => {
    result = rightHolder.identificationNumber.errorMessage !== '' ? true : result;
    result = rightHolder.address.value === '' || rightHolder.address.errorMessage !== '' ? true : result;
    result = rightHolder.name.value === '' || rightHolder.name.errorMessage !== '' ? true : result;
  });
  result = formValue.specialNotesOnFee.parentItem.errorMessage !== '' ? true : result;
  result = formValue.specialNotesOnFee.childItem.errorMessage !== '' ? true : result;
  result = formValue.other.errorMessage !== '' ? true : result;
  return result;
} 